/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-pgc-标签管理-一级标签
 */
'use strict';
angular.module("firstLevelLabelModule",["addOrEditTagServiceModule"]).
controller('firstLevelLabelCtrl', ['$scope','$state','$stateParams','httpService','addOrEditTagService','modalDialog',function($scope,$state,$stateParams,httpService,addOrEditTagService,modalDialog){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        }
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 20,
            "ITEMCOUNT": 2000
        };
        $scope.data = {
            channelId: $stateParams.channelId,
            channelName :$stateParams.channelName,
            selectedArray:[]//选中的数据
        }
    };

    function initData(){
		requestData();
		
    };
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    $scope.requestData = function(){
    	requestData();
    }
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectTag = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
    function requestData(){
        var params = {
      	  	channelId:$scope.data.channelId, 
      		currPage:$scope.page.CURRPAGE,
      		pageSize:$scope.page.PAGESIZE
        }
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/tag/firstTags.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        })
    }
    /**
     * [addOrEditTag description] 新建、编辑标签
     * @return {[type]} [description]
     */
    $scope.addOrEditTag = function(tagId,tagName){
    	var channelId = $scope.data.channelId;
    	addOrEditTagService.addOrEditTag(tagId,tagName,channelId).then(function(data) {
    		data.channelId = $scope.data.channelId;
	    	$scope.loadingPromise = httpService.http("/mcnadmin/admin/tag/addEditFirstTag.do", data, "post").then(function(data) {
	    		if(tagId==0){
	    			modalDialog.alertType('','新建标签成功','success');
	    		}else{
	    			modalDialog.alertType('','编辑标签成功','success');
	    		}
	    		requestData();
	        });
        });
    }
    
    /**
     * [addOrEditTag description] 删除标签
     * @return {[type]} [description]
     */
    $scope.deleteTags = function(id){
    	var txt = "";
    	var params = {
    		ids:''
    	};
    	if(id){
    		params.ids = id ;
    	}else{
    		params.ids = angular.packageIds($scope.data.selectedArray,",","id") ;
    	}
    	modalDialog.backConfirmModal("删除", "确认删除选中标签？", function() {
	            httpService.http("/mcnadmin/admin/tag/deleteTag.do", params, "post").then(function(data) {
	            	modalDialog.alertType('','删除标签成功','success');
	                requestData();
	            });
	        });
    }
}]);